export default __webpack_public_path__ + "static/media/thumb12_report1@2x.a07d921d.png";